var React = require('react');

function MagnifierInline (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\r\n\t.st0{fill:#FE0000;}\r\n"),React.createElement("defs",{"key":1}),React.createElement("g",{"key":2},React.createElement("g",null,React.createElement("path",{"className":"st0","d":"M508.9,493.8L353.1,338c32.4-35.9,52.2-83.3,52.2-135.3C405.3,90.9,314.4,0,202.7,0S0,90.9,0,202.7\r\n\t\t\ts90.9,202.7,202.7,202.7c52,0,99.4-19.9,135.3-52.2l155.8,155.8c2.1,2.1,4.8,3.1,7.5,3.1s5.5-1,7.5-3.1\r\n\t\t\tC513,504.7,513,498,508.9,493.8z M202.7,384c-100,0-181.3-81.3-181.3-181.3S102.7,21.3,202.7,21.3S384,102.7,384,202.7\r\n\t\t\tS302.6,384,202.7,384z"})))]);
}

MagnifierInline.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"512px","height":"512px","viewBox":"0 0 512 512","style":{"enableBackground":"new 0 0 512 512"},"xmlSpace":"preserve"};

module.exports = MagnifierInline;

MagnifierInline.default = MagnifierInline;
